<template>
  <div>
    <a-dialog
      v-model="show"
      width="900px"
      max-width="90vw"
      persistent
      scrollable
    >
      <v-card>
        <v-banner color="primaryLight1" sticky single-line tile>
          <v-toolbar color="primaryLight1">
            <span> {{ headingTitle }}</span>
            <v-spacer></v-spacer>
            <CloseIcon @click="close()" />
          </v-toolbar>
        </v-banner>
        <v-card-text>
          <v-form ref="refRemindAlertForm" v-model="valid" lazy-validation>
            <a-text-field
              class="textField"
              :label="$t('agenda.lblEmailSubject')"
              v-model="subject"
              required
              filled
              color="neutralGray"
              :maxlength="maxLength"
            ></a-text-field>
            <email-users-list
              :userlist="suggestedUserList"
              v-model="selectedUsers"
            >
            </email-users-list>
            <div class="error-element" v-if="noRecipientsMsg">
              {{ noRecipientsMsg }}
            </div>
            <div class="error-element" v-else-if="emailListValidation">
              {{ emailListValidation }}
            </div>
            <a-rich-text-editor
              v-if="showTextEditor"
              :label="$t('agenda.lblMessage')"
              v-model="message"
              class="mt-5"
              @descriptionChange="descriptionChanges"
              :isImageAllowed="isImageSupport"
              :section="section"
            ></a-rich-text-editor>
            <v-row class="pt-4">
              <v-col cols="12" sm="12">
                <upload-email-attachment
                  @attachments="onAddAttachments"
                  @valid="onAttachmentValid"
                ></upload-email-attachment>
              </v-col>
            </v-row>

            <div class="error-element" v-if="messageValidation">
              {{ messageValidation }}
            </div>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <menu-meeting-topic-documents v-if="!['survey', 'task', 'meetingDelete'].includes(section)"></menu-meeting-topic-documents>
          <v-spacer></v-spacer>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                class="mr-2"
                color="primaryDark"
                small
                v-bind="attrs"
                v-on="on"
                @click="sendEmail"
                :disabled="
                  isDescriptionWithImage ||
                  messageValidation !== null ||
                  selectedUsers.length === 0 ||
                  subjectValidation !== null ||
                  !isValidAttachment
                "
                ><span>{{ $t("btnSend") }}</span>
              </a-btn>
            </template>
            <span> {{ $t("btnSend") }} </span>
          </v-tooltip>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <a-btn
                color="secondary"
                small
                @click="close()"
                v-bind="attrs"
                v-on="on"
                ><span>{{ $t("btnCancel") }}</span>
              </a-btn>
            </template>
            <span> {{ $t("btnCancel") }} </span>
          </v-tooltip>
        </v-card-actions>
        <confirm-dialog ref="confirm" />
      </v-card>
    </a-dialog>
  </div>
</template>

<script>
import MeetingParticipants from "@/components/agenda/MeetingParticipants.vue";
import ConfirmDialog from "@/components/ConfirmDialog.vue";
import { mapState } from "vuex";
import EmailUsersList from "@/components/agenda/EmailUsersList.vue";
import { orderBy } from "lodash";
import UploadEmailAttachment from "./UploadEmailAttachment.vue";
import MenuMeetingTopicDocuments from "@/components/agenda/MenuMeetingTopicDocuments.vue";
import { TITLE_LENGTH_1000 } from "@/utils/constant";

export default {
  name: "EmailAlertNotification",
  data() {
    return {
      isValidAttachment: true,
      attachments: [],
      isDescriptionWithImage: null,
      valid: true,
      subject: this.emailTemplate.subject,
      message: this.emailTemplate.message,
      to: [],
      showTextEditor: false,
      isPrevent: false,
      isDirty: false,
      messageValidation: null,
      emailListValidation: null,
      subjectValidation: null,
      selectedUsers: this.defaulter ? this.defaulter : [],
      maxLength: TITLE_LENGTH_1000,
    };
  },
  components: {
    MeetingParticipants,
    ConfirmDialog,
    EmailUsersList,
    UploadEmailAttachment,
    MenuMeetingTopicDocuments
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    heading: {
      type: String,
      default: null,
    },
    emailTemplate: {
      type: Object,
      required: true,
    },
    defaulter: {
      type: Array,
      required: true,
    },
    suggestedList: {
      type: Array,
      required: true,
    },
    isImageSupport: {
      type: Boolean,
      default: false,
    },
    section: {
      type: String,
    },
  },
  mounted() {
    const thisInstance = this;
    setTimeout(() => {
      thisInstance.showTextEditor = true;
    }, 200);
  },
  watch: {
    subject(value) {
      if (String(value).trim() !== "") {
        this.subjectValidation = null;
      } else {
        this.subjectValidation = this.$t("widget.fieldRequired");
      }
    },
    message(value) {
      if (
        String(value)
          .replace(/<(.|\n)*?>/g, "")
          .replace(/\&nbsp;/g, "")
          .trim() !== ""
      ) {
        this.messageValidation = null;
      } else {
        this.messageValidation = this.$t("reqMsgRule");
      }
    },
    selectedUsers(emails) {
      if (!emails.length) {
        this.emailListValidation = this.$t("reqToListRule");
      } else {
        this.emailListValidation = null;
      }
    },
  },
  computed: {
    LoaderText() {
      return this.$t("LoaderText");
    },
    selectedLang() {
      return this.$i18n.locale;
    },
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value || false);
      },
    },
    ...mapState({
      userList: (state) => state.people.userList,
    }),
    suggestedUserList() {
      if (this.suggestedList) {
        let users = this.suggestedList.map((r) => {
          const existingPerson = this.userList.find((elem) => elem.id == r.id);
          const contactEmailIds = [];
          if (r.contactEmailIds && r.contactEmailIds.length > 0) {
            r.contactEmailIds.forEach((email) => {
              if (email != "" && r.email != email) {
                contactEmailIds.push(email);
              }
            });
          }
          return {
            ...r,
            contactEmailIds: contactEmailIds,
            email: r.email,
            name: r.firstName ? `${r.firstName} ${r.lastName}` : r.email,
            profilePhoto: existingPerson
              ? existingPerson.profilePhoto
              : r.profilePhoto,
          };
        });
        return orderBy(users, [(user) => user.name.toLowerCase()], ["asc"]);
      }
      return [];
    },
    selectedTenant() {
      return sessionStorage.getItem("tenantId");
    },
    tenantName() {
      const users = this.$auth.user[process.env.VUE_APP_TENANT_KEY];
      const tenant = users.find((u) => u.id === this.selectedTenant);
      if (tenant) {
        return tenant.name;
      }
      return "";
    },
    headingTitle() {
      if (this.heading) {
        return this.heading;
      }
      return this.$t("agenda.hNotification");
    },
    noRecipientsMsg() {
      if (this.suggestedList.length > 0) {
        return null;
      }
      if (
        this.emailTemplate.mailType == "meeting-voting-alert" ||
        this.emailTemplate.mailType == "meeting-convocation"
      ) {
        return this.$t("email.msgMeetingAlertRecipient");
      } else if (this.emailTemplate.mailType == "survey-alert") {
        return this.$t("email.msgSurveyAlertRecipient");
      } else if (this.emailTemplate.mailType == "task-alert") {
        return this.$t("email.msgTaskAlertRecipient");
      } else {
        return null;
      }
    },
  },
  methods: {
    descriptionChanges(val) {
      this.isDescriptionWithImage = val;
    },
    close() {
      this.$emit("close", false);
      this.$emit("input", false);
    },
    onParticipantChanged(attendees) {
      this.to = attendees;
    },
    async sendEmail() {
      if (this.$refs.refRemindAlertForm.validate()) {
        this.isDirty = false;
        this.messageValidation = null;
        this.emailListValidation = null;
        if (
          String(this.message)
            .replace(/<(.|\n)*?>/g, "")
            .replace(/\&nbsp;/g, "") === ""
        ) {
          return false;
        }
        if (!this.selectedUsers.length) {
          return false;
        }
        if (
          await this.$refs.confirm.open(
            this.$t("lblConfirm"),
            this.$t("agenda.msgConfirmSendEmail"),
            {
              removeAgreeBtn: false,
            }
          )
        ) {
          let toList = [];
          let toListData = [];
          this.selectedUsers.forEach((value) => {
            let name = value.email;
            if (value.firstName && value.lastName) {
              name = `${value.firstName} ${value.lastName}`;
            }
            toList.push([value.email, name]);
            toListData.push(value.email);
            if (value.contactEmailIds && value.contactEmailIds.length > 0) {
              value.contactEmailIds.forEach((email) => {
                if (email) {
                  toList.push([email, name]);
                  toListData.push(email);
                }
              });
            }
          });
          let personalisedData = {};

          personalisedData = toListData.reduce(
            (a, v) => ({
              ...a,
              [v]: this.createPersonalisedData(v),
            }),
            {}
          );

          const defaultVars = this.emailTemplate.dynamicVariables ?? {};
          const dynamicVars = {
            ...defaultVars,
            ...{
              subject: this.subject,
              message: this.message,
              tenant: sessionStorage.getItem("tenantId"),
              username: this.$auth.user.tenantUserName,
              tenantName: this.tenantName,
              emailDearRecipient: this.$t("email.emailDearRecipient", {
                username: this.$auth.user.name,
              }),
              emailPreHeader: this.$t("email.emailPreHeader"),
            },
          };
          const emailTemplateData = {
            toList: toList,
            subject: this.subject,
            isPersonalised: true,
            personalisedData,
            dynamicVariables: dynamicVars,
            mailType: this.emailTemplate.mailType ?? "",
            attachments: this.attachments,
          };
          await this.$notification
            .sendEmailWithAttachment(emailTemplateData, "remindAlert")
            .then((response) => {
              if (response.status !== "failed") {
                this.$emit("send", true);
                this.close();
              }
            })
            .catch((error) => {
              this.$emit("send", false);
            });
        }
      }
    },
    createPersonalisedData(email) {
      const user = this.selectedUsers.find(
        (u) =>
          u.email === email ||
          (u.contactEmailIds.length > 0 &&
            u.contactEmailIds.findIndex((item) => item === email) !== -1)
      );
      const username = user
        ? user.firstName && user.lastName
          ? `${user.firstName} ${user.lastName}`
          : user.name || email
        : email;
        
      const defaultVars = this.emailTemplate.dynamicVariables ?? {};
      return {
        ...defaultVars,
        ...{
          emailDearRecipient: this.$t("email.emailDearRecipient", {
            username: username,
          }),
          username,
          tenantName: this.tenantName,
          subject: this.subject,
          message: this.message,
          emailPreHeader: this.$t("email.emailPreHeader"),
        },
      };
    },
    onAddAttachments(files) {
      this.attachments = files;
    },
    onAttachmentValid(value) {
      this.isValidAttachment = value;
    },
  },
};
</script>

<style scoped>
.error-element {
  color: var(--v-error-base) !important;
}
</style>